<template lang="pug">
  footer#footer
    .footer__information(v-show="$route.path === '/result'")
      p #[a(href="https://www.taishinbank.com.tw/TSB/Mandatory-Disclosures-on-Personal-Information-Protection/index.html" target="_blank") 個資法告知事項] #[span |] #[a(href="https://www.taishinbank.com.tw/TSB/privacy-and-copyright/index.html" target="_blank") 隱私權保護及著作權說明]
    .footer__copyright
      p &copy; 台新國際商業銀行
      p 台新銀行營業部(總行)地址為：台北市中山區中山北路二段44號

</template>

<script>
export default {
  name: 'Footer',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>

#footer {

  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-direction: column;

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // height: vw(35);
  z-index: 2;

  @include desktop {
    // display: none;
  }

  .footer__information {
    padding: vw(6) 0;
    background: #c8c8c8;
    p, a {
      font-size: vw(15);
      text-align: center;
      line-height: lineHeight(15, 22);
      letter-spacing: .05em;
    }
    span {
      margin: 0 vw(5);
    }
    @include desktop {
      display: none;
    }
  }

  .footer__copyright {
    padding-bottom: env(safe-area-inset-bottom);
    background: #d70c18;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      // height: vw(35);
      color: #fff;
      font-size: vw(16);
      line-height: lineHeight(15, 22);
      letter-spacing: .1em;
      @include desktop {
        font-size: 12px;
      }
      &:first-child {
        padding-top: vw(6);
        @include desktop {
          padding-top: 6px;
        }
      }
      &:last-child {
        padding-bottom: vw(7);
        @include desktop {
          padding-bottom: 7px;
        }
      }
    }
  }

}

</style>
